import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import Q8Button from "../components/Q8Button";

const ColumnSelectorDialog = ({
  open,
  onClose,
  columns,
  visibleColumns,
  onVisibilityChange,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Seleziona Colonne</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2 }}>
            Colonne Non Modificabili (Blu)
          </Typography>
          {columns
            .filter((col) => col.columnType === "frozen")
            .map((column) => {
              const columnId = `${column.field}_frozen`;
              return (
                <FormControlLabel
                  key={columnId}
                  control={
                    <Checkbox
                      checked={visibleColumns[columnId] || false}
                      onChange={(e) =>
                        onVisibilityChange(
                          columnId,
                          e.target.checked,
                          column.field,
                          "frozen"
                        )
                      }
                    />
                  }
                  label={column.title}
                  sx={{ display: "block", ml: 0 }}
                />
              );
            })}

          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mt: 3, mb: 2 }}
          >
            Colonne Modificabili (Giallo)
          </Typography>
          {columns
            .filter((col) => col.columnType === "editable")
            .map((column) => {
              const columnId = `${column.field}_editable`;
              return (
                <FormControlLabel
                  key={columnId}
                  control={
                    <Checkbox
                      checked={visibleColumns[columnId] || false}
                      onChange={(e) =>
                        onVisibilityChange(
                          columnId,
                          e.target.checked,
                          column.field,
                          "editable"
                        )
                      }
                    />
                  }
                  label={column.title}
                  sx={{ display: "block", ml: 0 }}
                />
              );
            })}
        </Box>
      </DialogContent>
      <DialogActions>
        <Q8Button
          variant="secondary"
          label="Chiudi"
          onClick={onClose}
          size="small"
        />
      </DialogActions>
    </Dialog>
  );
};

ColumnSelectorDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  columns: PropTypes.array.isRequired,
  visibleColumns: PropTypes.object.isRequired,
  onVisibilityChange: PropTypes.func.isRequired,
};

export default ColumnSelectorDialog;
